const axios = require('axios');

export const _zipCode = async (zipCode) => {
    try {
        return axios({
            method: "get",
            url: `https://staging-proxy-api-googlemaps.contele.com.br/api/geocode/json?&language=en&res=format&address=${zipCode}&source=google&key=AIzaSyAtXCVd1EQ7WjarUx-HUGy3HORecdXnCtY`,
        });
    } catch (error) {
        console.error(error);
    }
};